import usePost from "./usePost";

function usePostMultipleImage() {
  const uploadImage = usePost({
    module: "storage",
  });

  let uploadImageLoading = uploadImage.isLoading;

  const uploadMultipleImage = (files) => {
    const newFiles = files ? [...files] : [];
    if (newFiles.length) {
      const promises = newFiles.map((file) => {
        const formData = new FormData();
        formData.append("file", file);
        return uploadImage.mutateAsync(formData);
      });
      return Promise.allSettled(promises);
    } else {
      return Promise.resolve(null);
    }
  };

  return { uploadMultipleImage, uploadImageLoading };
}

export default usePostMultipleImage;
